<template>
  <b-modal
    id="download-mobile-app"
    ref="download-mobile-app"
    size="lg-size"
    centered
    no-close-on-esc
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="content-wrapper download-app">
      <div class="img-wrap">
        <img
          src="assets/web/images/atto-app.png"
          width="320"
          height="381"
          title="Atto App"
          alt="Setup a Company Account"
        />
      </div>
      <div class="download-container">
        <h2 class="modal-title">
          {{ label.get("download_the_mobile_app") }}
        </h2>
        <p>
          {{ label.get("download_app_description_one") }}
        </p>
        <p>
          {{ label.get("download_app_description_two") }}
        </p>

        <ul class="social-icons">
          <li>
            <a
              href="https://itunes.apple.com/us/app/atto-employee-time-location/id1132847984"
              target="_blank"
              @click="close"
            >
              <i class="app-icon apple" />
              <div class="download-on">
                <p class="lg">App Store</p>
              </div>
            </a>
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=tech.zetta.atto"
              target="_blank"
              @click="close"
            >
              <i class="app-icon google" />
              <div class="download-on">
                <p class="lg">Google play</p>
              </div>
            </a>
          </li>
        </ul>
        <button class="get-started" @click="close">
          {{ label.get("get_started") }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import AppService from "../../core/base/shared/AppService";

    export default {
        name: "DownloadAppComponent",
        data(){
          return{

          }
        },
        mounted(){
              this.$refs["download-mobile-app"].show();
        },
        methods: {
            close(){
                this.$store.state.user.intro_step.download_app = true;
                AppService.updateIntroSteps({
                    intro_steps: JSON.stringify(this.$store.state.user.intro_step)
                }).then(() => {}).catch(() => {});
                this.$root.$emit('hideDownloadApp');
            }
        }
    }
</script>

<style lang="scss">
/* @media queries */
@mixin tabletAndMobile {
  @media (max-width: 980px) {
    @content;
  }
}
/* End of: @media queries */
.modal {
  .modal-content {
    .modal-body {
      .content-wrapper {
        &.download-app {
          padding: 72px;
        }
      }
    }
  }
}
.content-wrapper.download-app {
  display: flex;
  justify-content: space-between;
  padding: 104px 113px !important;
  @include tabletAndMobile {
    justify-content: center;
    padding: 40px !important;
  }
  .img-wrap {
    justify-content: center;
    display: inline-flex;
    @include tabletAndMobile {
      display: none;
    }
  }
  .download-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 340px;
    @include tabletAndMobile {
      width: 100%;
    }
    h2.modal-title {
      width: 230px;
      font-size: 2rem;
      line-height: 2rem;
      letter-spacing: -0.5px;
      color: #000000;
      font-family: "Calibre-Semibold";
      margin-bottom: 12px;
    }
    p {
      font-family: $roboto-font;
      font-weight: $roboto-regular;
      color: $atto-not-active;
      font-size: 1.375rem;
      line-height: 1.875rem;
      margin-bottom: 32px;
      color: #262626;
      font-family: "Calibre-Regular";
    }
    ul.social-icons {
      display: flex;
      flex-direction: row;
      margin-bottom: 8px;
      width: 100%;
      li {
        width: 100%;
        height: 48px;
        flex-grow: 1;
        display: inline-flex;
        width: 100%;
        &:first-child {
          margin-right: 12px;
        }
        a {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 2px solid #efefef;
          border-radius: 4px;
          i {
            margin-right: 12px;
            width: 24px;
            height: 24px;
            display: inline-flex;
            &.apple {
              background: url("~@assets/images/apple-logo.svg") no-repeat center
                center;
            }
            &.google {
              background: url("~@assets/images/play-logo.svg") no-repeat center
                center;
            }
          }
          p.sm {
            font-size: 8px;
            line-height: 8px;
            font-weight: 400;
            font-family: $roboto-font;
            color: #262626;
            margin-bottom: 4px;
          }
          p.lg {
            font-size: 1rem;
            line-height: 0.875rem;
            font-family: "Calibre-Medium";
            text-transform: capitalize;
            color: #262626;
            margin-bottom: 0;
          }
        }
      }
    }
    .get-started {
      width: 100%;
      text-transform: uppercase;
      background: #00b9cb;
      border: none;
      border-radius: 4px;
      font-size: 1.25rem;
      line-height: 1.375rem;
      text-transform: capitalize;
      font-family: "Calibre-Semibold";
      &:hover {
        background: #0a9ead;
        color: #ffffff;
      }
    }
  }
}
</style>
